class BannerCarouselFunctionality {
  constructor(sectionId, interval = null) {
    this.sectionId = sectionId;
    this.track = document.querySelector(`.slideshow--${sectionId}`);
    this.slides = document.querySelectorAll(`.banner-slides--${sectionId}`);
    this.currentIndex = 0;
    this.isDragging = false;
    this.startPos = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;
    this.animationID = null;
    this.slideWidth = this.track.clientWidth;

    this.eventListenerForSlides();
    if (interval) this.autoScroll(interval);
  }

  changeSlide(targetIndex) {
    this.currentIndex = targetIndex;
    this.updateSlidePosition();
    this.setPositionByIndex();
    this.changeActiveControl(this.currentIndex);
  }

  updateSlidePosition() {
    this.track.style.transition = 'transform 1s ease';
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
  }

  setPositionByIndex() {
    this.currentTranslate = -this.currentIndex * this.slideWidth;
    this.prevTranslate = this.currentTranslate;
    this.setSliderPosition();
  }

  setSliderPosition() {
    this.track.style.transform = `translateX(${this.currentTranslate}px)`;
  }

  animation() {
    this.setSliderPosition();
    if (this.isDragging) {
      this.track.style.transition = 'none';
      requestAnimationFrame(() => this.animation());
    }
  }

  autoScroll(interval) {
    setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.updateSlidePosition();
      this.setPositionByIndex();
      this.changeActiveControl(this.currentIndex);
    }, interval);
  }

  touchStart(index) {
    return (event) => {
      this.isDragging = true;
      this.startPos = this.getPositionX(event);
      this.animationID = requestAnimationFrame(() => this.animation());
      this.track.style.cursor = 'grabbing';
    };
  }

  touchMove(event) {
    if (!this.isDragging) return;
    const currentPosition = this.getPositionX(event);
    this.currentTranslate = this.prevTranslate + (currentPosition - this.startPos);
  }

  touchEnd() {
    cancelAnimationFrame(this.animationID);
    this.isDragging = false;
    const movedBy = this.currentTranslate - this.prevTranslate;

    if (movedBy < -50 && this.currentIndex < this.slides.length - 1) {
      this.currentIndex += 1;
    } else if (movedBy > 50 && this.currentIndex > 0) {
      this.currentIndex -= 1;
    }

    this.updateSlidePosition();
    this.setPositionByIndex();
    this.changeActiveControl(this.currentIndex);
    this.track.style.cursor = 'grab';
  }

  getPositionX(event) {
    return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
  }
  changeActiveControl(blockIndex) {
    document.querySelectorAll('.slide-control').forEach((btn) => btn.classList.remove('active-slide-control'));
    const selectedControl = document.querySelector(`.control-index--${this.sectionId}-${blockIndex}`);
    if (selectedControl) selectedControl.classList.add('active-slide-control');
  }

  eventListenerForSlides() {
    this.slides.forEach((slide, index) => {
      slide.addEventListener('touchstart', this.touchStart(index));
      slide.addEventListener('touchmove', (e) => this.touchMove(e));
      slide.addEventListener('touchend', () => this.touchEnd());

      slide.addEventListener('mousedown', this.touchStart(index));
      slide.addEventListener('mousemove', (e) => this.touchMove(e));
      slide.addEventListener('mouseup', () => this.touchEnd());
      slide.addEventListener('mouseleave', () => {
        if (this.isDragging) this.touchEnd();
      });

      slide.addEventListener('dragstart', (e) => e.preventDefault());
    });
  }
}